import * as types from './types'
import axios from 'axios'
import { processRecords } from '@/store/utils'

const actions = {
  INIT ({ commit, firebase }) {},
  async [types.GET_LIST] ({ commit, firebase, rootGetters }, group) {
    const currentCompany = rootGetters['global/currentCompanyId']

    commit('setLoading', true)
    commit('setList', [])

    firebase
      .firestore()
      .collection(`companies/${currentCompany}/users`)
      .where('group', '==', group)
      .onSnapshot(querySnapshot => {
        const records = processRecords(querySnapshot)

        commit('setLoading', false)
        commit('setList', records)
      })
  },
  [types.CREATE] ({ firebase }, payload) {
    return firebase.auth().currentUser.getIdTokenResult().then(result => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${result.token}`

      return axios
        .post('/api/createUser', payload)
        .then(({ status }) => {
          if (status === 200) {
            return true
          }
        })
    })
  }
}

export default actions
